export default __webpack_public_path__ + "static/media/Regulamin_Shake_Tips.301abc3f.pdf";